import React from 'react';
import styled from 'styled-components';
import { colorMediumGray, colorRed } from '../../config/theme';

const InputContainer = styled.label<{invalid?: boolean, checked?: boolean}>`
    ${(props) => props.invalid ? `color: ${colorRed};` : ''}

    position: relative;
    padding-left: 2.5rem;
    display: inline-block;
    cursor: pointer;

    ::before {
        position: absolute;
        display: inline-block;
        left: 0;
        width: 25px;
        height: 25px;
        border: solid 1px ${(props) => props.invalid ? colorRed : colorMediumGray};
        text-align: center;

        ${(props) => props.checked ? `
            content: '✓';
            font-size: 1.8rem;
            line-height: 1.5rem;
        ` : `
            content: '';
        `}
    }

    input[type=checkbox] {
        display: none;
    }
`;

type CheckboxInputProps = {
    children: React.ReactNode;
    required?: boolean;
    invalid?: boolean;
    checked?: boolean;
    onChange: (checked: boolean) => void;
}

export function CheckboxInput(props: CheckboxInputProps) {
    return <InputContainer invalid={props.invalid} checked={props.checked}>
        <input
            type='checkbox'
            required={props.required}
            checked={!!props.checked}
            onChange={(e) => props.onChange(e.target.checked)}
        />
        {props.children}
    </InputContainer>
}
